import Button from '@blaze-react/button';
import PropTypes from 'prop-types';

const MultipleDeepLink = ({ close, brokerDeepLinks, handleClick }) => {
  let numberOfContactsVariant = 1;
  if (brokerDeepLinks.length === 2) {
    numberOfContactsVariant = 2;
  }

  if (brokerDeepLinks.length > 2) {
    numberOfContactsVariant = 3;
  }

  return (
    <div className="ecommerce__form__overlay">
      <div className={`ecommerce__form__modal ecommerce__form__modal--phone-${numberOfContactsVariant}`}>
        <div className="ecommerce__form ecommerce__form--phone">
          <div role="button" className="ecommerce__form__close" onClick={close}>
            <i className="fas fa-times" />
          </div>

          <h2 className="ecommerce__form__phone-title">
            Visit listing on broker's website
          </h2>

          <div className="ecommerce__form__phone-numbers">
            {brokerDeepLinks.map((brokerDeepLink, index) => (
              <Button
                key={`deep-link-${index}`}
                className="ecommerce__form__deep-link"
                icon="fas fa-desktop"
                title={brokerDeepLink.brokerName}
                onClick={() => handleClick(brokerDeepLink)}>
                {brokerDeepLink.brokerName}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

MultipleDeepLink.propTypes = {
  close: PropTypes.func.isRequired,
  brokerDeepLinks: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default MultipleDeepLink;
